// extracted by mini-css-extract-plugin
export default {"button":"QuestionTopicsHeader_button__b1q1d"};